import { HeaderShell, HeaderInner, Nav, ContactLink } from "./Header.styled";
import { P360_LOGO } from "../../constants/assets";
import { FiPhone } from "react-icons/fi";

export default function Header() {
  return (
    <HeaderShell>
      <HeaderInner>
        <img src={P360_LOGO} alt="Portal 360" style={{ height: 60 }} />
        <Nav>
          <a href="#about">About</a>
          <a href="#features">Features</a>
          <a href="#ready">Ready to digitalize</a>
        </Nav>
        <ContactLink href="#ready">
          <FiPhone size={16} /> Contact
        </ContactLink>
      </HeaderInner>
    </HeaderShell>
  );
}
